// original: https://git.hubteam.com/HubSpot/ui-addon-conversations-settings/blob/a3074a0a75dfbdb23ad52e6a2e9a41799014b3b1/static/js/team/operators/toOptionWithDepth.tsx
import { EERIE } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { getTeamContainsFreeUsers } from './getTeamContainsFreeUsers';
import { getId, getName, getNumRoutableUsers } from './getters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getDropdownStyle = levelsDeep => {
  return {
    paddingLeft: 20 * levelsDeep
  };
};
export const UserCountNumber = styled.span.withConfig({
  displayName: "toOptionWithDepth__UserCountNumber",
  componentId: "sc-1xvl7py-0"
})(["color:", ";"], EERIE);

// couldn't use an arrow function because Prettier didn't like the generic parameter
function getText(team, isUngatedForHelpDeskRoutingScopeFiltering) {
  const numRoutableTeamUsers = getNumRoutableUsers(team);
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx("span", {
      children: getName(team)
    }), typeof numRoutableTeamUsers === 'number' ? /*#__PURE__*/_jsx(UserCountNumber, {
      className: "m-left-1",
      children: isUngatedForHelpDeskRoutingScopeFiltering ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.users-and-teams.team.routableUser",
        options: {
          count: numRoutableTeamUsers
        }
      }) : ` (${numRoutableTeamUsers})`
    }) : null]
  });
}

// couldn't use an arrow function because Prettier didn't like the generic parameter
export function toOptionWithDepth(team, depth, isUngatedForHelpDeskRoutingScopeFiltering) {
  return {
    containsFreeUsers: getTeamContainsFreeUsers(team),
    dropdownStyle: getDropdownStyle(depth),
    text: getText(team, isUngatedForHelpDeskRoutingScopeFiltering),
    title: getName(team) || '',
    value: getId(team) || 0
  };
}